import { useState } from "react";
import { supabase } from "./supabaseclient";
import logo from "./logo.png";
import "./Login.css";

export default function PasswordStart() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setMsg(""); setErr("");

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: "https://triplewstorage.com/set-password",
    });

    if (error) setErr(error.message);
    else setMsg("Check your email for the reset link.");

    setLoading(false);
  };

  return (
    <div className="login-wrap">
      <form onSubmit={onSubmit} className="login-card">
        <img src={logo} alt="Logo" className="logo" />

        <h2>Forgot your password?</h2>
        <p className="subtext">Enter your email to get a reset link.</p>

        <input
          type="email"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        {err && <div className="err">{err}</div>}
        {msg && <div className="msg">{msg}</div>}

        <button disabled={loading}>
          {loading ? "Sending..." : "Send reset link"}
        </button>

        <a href="/login" className="muted-link">Back to sign in</a>
      </form>
    </div>
  );
}
